import { useEffect, useState } from 'react';

export const useDebouncedActivitySearch = (value: string, delayMs: number): string => {
  const normalizedValue = value.trim();
  const [debounced, setDebounced] = useState(normalizedValue);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => setDebounced(normalizedValue), delayMs);

    return (): void => {
      window.clearTimeout(timeoutId);
    };
  }, [delayMs, normalizedValue]);

  return debounced;
};
